/*
@PRODUCT_FEATURE: M 1.5.0
*/
import View from './View';

export { default as View, getLoaderStyles } from './View';
export default View;
